import turkeyData from './turkey-locations.json';

/**
 * Turkey location data structure
 * Format: { "PROVINCE": { "DISTRICT": ["Neighborhood 1", "Neighborhood 2"] } }
 */
export interface TurkeyLocationData {
  [province: string]: {
    [district: string]: string[];
  };
}

export const TURKEY_LOCATIONS: TurkeyLocationData = turkeyData;

/**
 * Get all Turkish provinces (81 provinces)
 * @returns Sorted array of province names
 */
export const getProvinces = (): string[] => {
  return Object.keys(TURKEY_LOCATIONS).sort();
};

/**
 * Get all districts for a given province
 * @param province Province name (e.g., "ISTANBUL", "ANKARA")
 * @returns Sorted array of district names
 */
export const getDistricts = (province: string): string[] => {
  if (!province || !TURKEY_LOCATIONS[province]) return [];
  return Object.keys(TURKEY_LOCATIONS[province]).sort();
};

/**
 * Get all neighborhoods for a given district
 * @param province Province name
 * @param district District name
 * @returns Sorted array of neighborhood names
 */
export const getNeighborhoods = (province: string, district: string): string[] => {
  if (!province || !district || !TURKEY_LOCATIONS[province]?.[district]) return [];
  return TURKEY_LOCATIONS[province][district].sort();
};

/**
 * Get the total number of districts in a province
 * @param province Province name
 * @returns Number of districts
 */
export const getDistrictCount = (province: string): number => {
  return getDistricts(province).length;
};

/**
 * Get the total number of neighborhoods in a district
 * @param province Province name
 * @param district District name
 * @returns Number of neighborhoods
 */
export const getNeighborhoodCount = (province: string, district: string): number => {
  return getNeighborhoods(province, district).length;
};

/**
 * Check if a province exists
 * @param province Province name
 * @returns True if province exists
 */
export const provinceExists = (province: string): boolean => {
  return !!TURKEY_LOCATIONS[province];
};

/**
 * Check if a district exists in a province
 * @param province Province name
 * @param district District name
 * @returns True if district exists
 */
export const districtExists = (province: string, district: string): boolean => {
  return !!TURKEY_LOCATIONS[province]?.[district];
};
